












import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { GQL_order_order } from '@/queries/__generated__/order';
import { GQL_invoice_invoice, GQL_invoice_invoice_invoiceOverdueNotices } from '@/queries/__generated__/invoice';

export type DocumentShowType = 'offer' | 'order' | 'orderConfirmation' | 'packingSlip' | 'invoice' | 'overdueNotice';

@Component
export default class DocumentHeader extends Vue {
  @Prop({ type: Number, default: 1 }) public page!: number;
  @Prop({ type: Number, default: 1 }) public totalPages!: number;
  @Prop(Object) public document!: GQL_order_order | GQL_invoice_invoice;
  @Prop(Object) public lastOverdueNotice?: GQL_invoice_invoice_invoiceOverdueNotices;
  @Inject() public documentShowType!: DocumentShowType;

  private get documentNumber() {
    const name = (this.$t(`Document.${this.documentShowType}`) as string).toUpperCase();
    const number = this.document.number || '';

    let documentNumber = `${name} ${number}`;

    if (this.documentShowType === 'overdueNotice' && this.lastOverdueNotice) {
      documentNumber = this.$t('Invoice.OverdueNotice.noticeFor', {
        ordinal: this.$tc('ordinal', this.lastOverdueNotice!.orderNumber),
        invoice: this.document.number,
      }).toString();
    }
    return documentNumber;
  }
}
